import styles from './FJVoiceCloningList.module.less';
import FJVoiceCloningItemContainer from '../container/FJVoiceCloningItemContainer.jsx';
import FJLocalStore from '../../../store/FJLocalStore.js';
import FJButton from '../../../common/components/FJButton/FJButton.jsx';
import FJAddIcon from '../../../assets/svg/add.svg?react';
import FJVerticalScroller from '../../../common/components/FJScroller/FJVerticalScroller.jsx';
import PropTypes from 'prop-types';

const FJVoiceCloningList = props => {
    const { list = [], toCreateClone } = props;
    return (
        <div className={styles.box}>
            <div className={styles.header}>
                <div className={styles.title}>{FJLocalStore._('voice-cloning')}</div>
                <FJButton
                    text='create-voice-clone'
                    type='gradient'
                    className={styles.btn}
                    icon={<FJAddIcon />}
                    onClick={toCreateClone}
                />
            </div>
            <FJVerticalScroller className={styles.scroll_box}>
                <div className={styles.content_box}>
                    {list.map((item, index) => {
                        return <FJVoiceCloningItemContainer key={index} info={item} />;
                    })}
                </div>
            </FJVerticalScroller>
        </div>
    );
};

FJVoiceCloningList.propTypes = {
    list: PropTypes.array,
    toCreateClone: PropTypes.func,
};
export default FJVoiceCloningList;
